module.exports = __webpack_public_path__ + "media/images/highligts_image_3-473b95115953ed5c803de2bf50ed9d7a.png";